import { jsx as _jsx } from "react/jsx-runtime";
import { StackedBarChart, TileFooter, ChartTooltip, TileCard, } from '@cmd/ui-components';
import { useGetData } from '@cmd/ui-utilities';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { dateRangeSelector } from '../../../components/LandingPageHeader/LandingPageHeader';
import { organizationSelector } from '../../../state/orgIdState';
import leadsApi, { LeadsDataSource, LeadsResource } from '../../../utils/apis/leadsApiUtils';
import { getNvisionAnalyzeLeadsUrl } from '../../../utils/urlUtils';
import './TopTradeInVehiclesByLeads.scss';
const tileConfigs = {
    [LeadsDataSource.ICO]: {
        sourceMessage: (intl) => intl.formatMessage({
            id: 'SOURCE_NVISION',
            defaultMessage: 'nVision',
        }),
    },
};
const leadsByTradeInFormatter = (response, intl) => {
    const leadsByTradeIn = response?.leadsByTradeIn || [];
    const lastUpdatedUTC = response?.lastUpdatedUTC || '';
    const internalLabel = intl.formatMessage({
        id: 'TRADE_IN_SOURCE_TYPE.INTERNAL',
        defaultMessage: 'Internal',
    });
    const externalLabel = intl.formatMessage({
        id: 'TRADE_IN_SOURCE_TYPE.EXTERNAL',
        defaultMessage: 'External',
    });
    return {
        chartData: leadsByTradeIn.map(({ leadMakeModel, externalLeads, internalLeads, }) => ({
            description: leadMakeModel,
            values: [
                { value: internalLeads, category: internalLabel },
                { value: externalLeads, category: externalLabel },
            ],
        })),
        lastUpdatedUTC,
    };
};
const TradeInsThatDroveLeads = ({ 'data-testid': dataTestId, limit = 10, }) => {
    const intl = useIntl();
    const testId = `${dataTestId || 'ids'}-trade-ins-that-drove-leads`;
    const { sourceMessage } = tileConfigs[LeadsDataSource.ICO] || { sourceMessage: () => '' };
    const { startDate, endDate } = useSelector(dateRangeSelector);
    const orgId = useSelector(organizationSelector);
    const params = {
        orgId,
        startDate,
        endDate,
        limit: limit || 10,
    };
    const endpoint = `${LeadsDataSource.ICO}/${LeadsResource.LEADS_BY_TRADE_IN}`;
    const { data, isLoading, error, } = useGetData(() => leadsApi[endpoint].get(params), params, (res) => leadsByTradeInFormatter(res, intl));
    const { chartData = [], lastUpdatedUTC, } = data || {};
    const tooltipFunc = (category, color, subcategory, value) => (_jsx(ChartTooltip, { category: category, color: color, subcategory: subcategory, value: value }));
    return (_jsx(TileCard, { title: intl.formatMessage({
            id: 'TRADE_INS_THAT_DROVE_LEADS_TILE_TITLE',
            defaultMessage: 'Top Trade-In Vehicles by Leads',
        }), description: intl.formatMessage({
            id: 'TRADE_INS_THAT_DROVE_LEADS_TILE_DESC',
            defaultMessage: 'Lead count for your highest ICO Trade-In Models',
        }), className: "trade-ins-that-drove-leads", error: !!error, isLoading: isLoading, noData: (chartData || []).length === 0, "data-testid": testId ? `${testId}-widget-tile` : 'ids-widget-tile', footer: (_jsx(TileFooter, { sourceLabel: sourceMessage(intl), sourceLink: getNvisionAnalyzeLeadsUrl({ startDate, endDate }), "data-testid": testId, lastUpdated: new Date(lastUpdatedUTC || '') })), children: _jsx(StackedBarChart, { data: chartData || {}, "data-testid": testId, tooltipFunc: tooltipFunc }) }));
};
export default TradeInsThatDroveLeads;
